module.exports = "<p>\n  config-child-page works!\n</p>\n"